export const language = 'ru'
export const fallbackLanguage = 'ru'
export const moneySymbol = '₽'
